import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faSave,
  faTimes,
  faPen,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import Popup from "reactjs-popup";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getToDate } from "../../utils/utils";
import SimpleReactValidator from "simple-react-validator";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { PopupMessage } from "../../utils/utils";
import { leaseDateFormat } from "../../utils/utils";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class Waiver extends React.Component {
  countError = "";
  state = {
    popupHeading: "",
    leaseData: {},
    totalGla: "",
    periodDurationDD: "",
    periodDurationYY: "",
    periodDurationMM: "",
    currentIndex: null,
    disableOnEdit: false,
    readOnEdit: false,
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: "",
    productName: "",
    productId: "",
    to: "",
    index_val: "",
    delete: false,
    revalue: "",
    showAddBtn: false,
    isOpen: false,
    showForm: true,
    fromDate: "",
    toDate: "",
    leaseTermDD: "",
    leaseTermMM: "",
    leaseTermYY: "",
    periodTermDD: "",
    periodTermMM: "",
    periodTermYY: "",
    renewalLeaseTermDD: "",
    renewalLeaseTermMM: "",
    renewalLeaseTermYY: "",
    period: 1,
    rentalDetails: [],
    products: [],
    redirect: false,
    rentMinusCam: false,
    rentFitoutMinusCam: false,
    pureRevenueShareMinusCam: false,
    pureRevenueSalesShareMinusCam: false,
    pureRevenueProduct: false,
    pureRevenueSalesProduct: false,
    minimumGuaranteeRentPlusCam: false,
    minimumGuaranteeRentPlusFitout: false,
    minimumGuaranteeRentRevenueShareSalesRange: false,
    minimumGuaranteeRentRevenueShareProduct: false,
    minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
    minimumGuaranteeRentRevenueShareMinimum: false,
    initialValues: {
      rentalLogic: {
        fromDate: "",
        toDate: "",
        rentalUom: "",
        rentDueDate: "",
        rentRate: "",
        rentRateTerm: "",
        onArea: "",
        rentFrequency: "",
        rentalLogicValue: "",
        rentalLogicText: "",
        minusCamPercent: "",
        revenueShareTerm: "",
        slabs: [],
        unit: "",
      },
      totalSlabs: "",
    },
    showMinusCam: false,
    biFurcateRentVal: 0,
    units: [],
    isUnitBifurcate: false,
    isRentAutocalculate: false,
    isRentCheckboxChecked: false,
  };

  constructor(props) {
    super(props);
    console.log(this.props.match.params.id);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        countError: "Validation has failed!",
      },
    });

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  changeProduct(newValue, values, index) {
    this.state.initialValues.rentalLogic.slabs[index].product = newValue.value;
    this.state.initialValues.rentalLogic.slabs[index].productName =
      newValue.label;
    this.setState({});
    console.groupEnd();
  }

  setPopupHeading() {
    if (
      this.state.leaseData.type == "" ||
      this.state.leaseData.type == "original"
    ) {
      return "Create Lease";
    } else if (this.state.leaseData.type == "amend") {
      return "Amend Lease";
    } else if (this.state.leaseData.type == "extend") {
      return "Extend Lease";
    } else if (this.state.leaseData.type == "renew") {
      return "Renew Lease";
    } else if (this.state.leaseData.type == "terminate") {
      return "Terminate Lease";
    } else {
      return "Create Lease";
    }
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  editRental(index, values) {
    console.log(values);
    if (this.state.rentalDetails[index].unit !== undefined) {
      this.setState({ isUnitBifurcate: true, biFurcateRentVal: 1 });
    } else {
      this.setState({ isUnitBifurcate: false, biFurcateRentVal: 0 });
    }
    if (this.state.rentalDetails[index].rentalLogic !== undefined) {
      if (
        this.state.rentalDetails[index].rentalLogic.escalationPercent !==
        undefined
      ) {
        this.setState({
          isRentAutocalculate: true,
          isRentCheckboxChecked: true,
        });
      } else {
        this.setState({
          isRentAutocalculate: false,
          isRentCheckboxChecked: false,
        });
      }
    } else {
      this.setState({
        isRentAutocalculate: false,
        isRentCheckboxChecked: false,
      });
    }

    this.state.currentIndex = index;
    this.state.disableOnEdit = true;
    this.state.readOnEdit = true;
    this.state.period = this.state.rentalDetails[index].period;
    this.state.initialValues.totalSlabs =
      this.state.rentalDetails[index].slabNumber;
    if (this.state.rentalDetails[index].rentalLogicText.includes("Minus CAM")) {
      this.setState({
        showMinusCam: true,
      });
    } else {
      this.setState({
        showMinusCam: false,
      });
    }
    this.setState({
      showForm: true,
      showAddBtn: true,
      periodTermDD: this.state.rentalDetails[index].periodTermDD,
      periodTermMM: this.state.rentalDetails[index].periodTermMM,
      periodTermYY: this.state.rentalDetails[index].periodTermYY,
    });
    if (
      this.state.rentalDetails[index].rentalLogicValue === "1" ||
      this.state.rentalDetails[index].rentalLogicValue === "2"
    ) {
      this.setState({
        rentMinusCam: true,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "3" ||
      this.state.rentalDetails[index].rentalLogicValue === "4"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: true,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "5" ||
      this.state.rentalDetails[index].rentalLogicValue === "6"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: true,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "7" ||
      this.state.rentalDetails[index].rentalLogicValue === "8"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: true,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "9" ||
      this.state.rentalDetails[index].rentalLogicValue === "10"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: true,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "11" ||
      this.state.rentalDetails[index].rentalLogicValue === "12"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: true,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "13" ||
      this.state.rentalDetails[index].rentalLogicValue === "14" ||
      this.state.rentalDetails[index].rentalLogicValue === "15"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: true,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "16" ||
      this.state.rentalDetails[index].rentalLogicValue === "17"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: true,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "18" ||
      this.state.rentalDetails[index].rentalLogicValue === "19"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: true,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "20" ||
      this.state.rentalDetails[index].rentalLogicValue === "21"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: true,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "22" ||
      this.state.rentalDetails[index].rentalLogicValue === "23"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: true,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "24" ||
      this.state.rentalDetails[index].rentalLogicValue === "25" ||
      this.state.rentalDetails[index].rentalLogicValue === "26" ||
      this.state.rentalDetails[index].rentalLogicValue === "27"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: true,
      });
    } else {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    }
    values.rentalLogic = { ...this.state.rentalDetails[index] };
    this.state.fromDate = this.state.rentalDetails[index].fromDate;
    this.state.toDate = this.state.rentalDetails[index].toDate;
    this.state.initialValues.rentalLogic.unit =
      this.state.rentalDetails[index].unit;
    this.setState({});
  }

  addRentalDetails = (values, resetForm, setFieldValue) => {
    console.log(values);
    if (this.state.currentIndex === null) {
      if (!this.validator.allValid()) {
        this.validator.showMessages();
        return false;
      }
      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });

        return false;
      } else if (this.state.toDate == values.to) {
        if (this.state.biFurcateRentVal === 0) {
          this.state.showForm = false;
          this.state.showAddBtn = false;
        }
      }
      values.rentalLogic.rentalLogicText =
        this.state.initialValues.rentalLogic.rentalLogicText;
      var rentalVal = this.state.initialValues.rentalLogic.rentalLogicValue;
      var _rentalDetails = this.state.rentalDetails;
      //   values.rentalLogic.period = this.state.period;
      values.rentalLogic.fromDate = this.state.fromDate;
      values.rentalLogic.toDate = this.state.toDate;
      //   values.rentalLogic.periodTermYY = this.state.periodTermYY;
      //   values.rentalLogic.periodTermMM = this.state.periodTermMM;
      //   values.rentalLogic.periodTermDD = this.state.periodTermDD;
      values.rentalLogic.slabs = this.state.initialValues.rentalLogic.slabs;
      values.rentalLogic.unit = this.state.initialValues.rentalLogic.unit;
      _rentalDetails.push(values.rentalLogic);
      var _initialValues = this.state.initialValues;
      // _initialValues.rentalLogic.rentalLogicValue = "";
      _initialValues.rentalLogic.slabs = [];
      this.state.initialValues.totalSlabs = "";
      this.setState({
        rentalDetails: _rentalDetails,
        // rentMinusCam: false,
        // rentFitoutMinusCam: false,
        // pureRevenueShareMinusCam: false,
        // pureRevenueSalesShareMinusCam: false,
        // pureRevenueProduct: false,
        // pureRevenueSalesProduct: false,
        // minimumGuaranteeRentPlusCam: false,
        // minimumGuaranteeRentPlusFitout: false,
        // minimumGuaranteeRentRevenueShareSalesRange: false,
        // minimumGuaranteeRentRevenueShareProduct: false,
        // minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        // minimumGuaranteeRentRevenueShareMinimum: false,
      });
      //   this.state.period++;
      //   this.state.periodTermDD = "";
      //   this.state.periodTermMM = "";
      //   this.state.periodTermYY = "";
      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      if (this.state.rentalDetails.length > 0) {
        this.mainFormValidator.hideMessages();
      }
      setFieldValue("rentalLogic.rentRate", "");
      setFieldValue("rentalLogic.escalationPercent", "");
      // resetForm();
    } else {
      if (!this.validator.allValid()) {
        this.validator.showMessages();
        return false;
      }
      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        return false;
      } else if (this.state.toDate == values.to) {
        if (this.state.biFurcateRentVal === 0) {
          this.state.showForm = false;
          this.state.showAddBtn = false;
        }
      }
      values.rentalLogic.rentalLogicText =
        this.state.initialValues.rentalLogic.rentalLogicText;
      var _rentalDetails = this.state.rentalDetails;
      values.rentalLogic.period = this.state.period;
      values.rentalLogic.fromDate = this.state.fromDate;
      values.rentalLogic.toDate = this.state.toDate;
      values.rentalLogic.periodTermYY = this.state.periodTermYY;
      values.rentalLogic.periodTermMM = this.state.periodTermMM;
      values.rentalLogic.periodTermDD = this.state.periodTermDD;
      values.rentalLogic.slabs = this.state.initialValues.rentalLogic.slabs;
      _rentalDetails[this.state.currentIndex] = { ...values.rentalLogic };
      var _initialValues = this.state.initialValues;
      _initialValues.rentalLogic.rentalLogicValue = "";
      _initialValues.rentalLogic.slabs = [];
      this.state.initialValues.totalSlabs = "";
      this.setState({
        rentalDetails: _rentalDetails,
        // rentMinusCam: false,
        // rentFitoutMinusCam: false,
        // pureRevenueShareMinusCam: false,
        // pureRevenueSalesShareMinusCam: false,
        // pureRevenueProduct: false,
        // pureRevenueSalesProduct: false,
        // minimumGuaranteeRentPlusCam: false,
        // minimumGuaranteeRentPlusFitout: false,
        // minimumGuaranteeRentRevenueShareSalesRange: false,
        // minimumGuaranteeRentRevenueShareProduct: false,
        // minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        // minimumGuaranteeRentRevenueShareMinimum: false,
      });
      this.state.period++;
      this.state.periodTermDD = "";
      this.state.periodTermMM = "";
      this.state.periodTermYY = "";
      // values.rentalLogic.unit = "";
      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      if (this.state.rentalDetails.length > 0) {
        this.mainFormValidator.hideMessages();
      }
      // resetForm();
      this.state.currentIndex = null;
      this.state.disableOnEdit = false;
      this.state.readOnEdit = false;
      this.setState({});
    }
  };

  resetRentalDetails = (values, resetForm) => {
    var _initialValues = this.state.initialValues;
    _initialValues.rentalLogic.rentalLogicValue = "";
    _initialValues.rentalLogic.slabs = [];
    this.state.initialValues.totalSlabs = "";
    this.setState({
      // rentalDetails: _rentalDetails,
      rentMinusCam: false,
      rentFitoutMinusCam: false,
      pureRevenueShareMinusCam: false,
      pureRevenueSalesShareMinusCam: false,
      pureRevenueProduct: false,
      pureRevenueSalesProduct: false,
      minimumGuaranteeRentPlusCam: false,
      minimumGuaranteeRentPlusFitout: false,
      minimumGuaranteeRentRevenueShareSalesRange: false,
      minimumGuaranteeRentRevenueShareProduct: false,
      minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
      minimumGuaranteeRentRevenueShareMinimum: false,
    });
    this.state.period++;
    // this.state.fromDate = this.state.toDate;
    this.state.periodTermDD = "";
    this.state.periodTermMM = "";
    this.state.periodTermYY = "";
    this.setState({
      fromDate: getToDate(this.state.toDate, 2, 0, 0),
      toDate: "",
    });
    if (this.state.rentalDetails.length > 0) {
      this.mainFormValidator.hideMessages();
    }
    resetForm();
  };

  addSlabRow = (e) => {
    this.state.initialValues.totalSlabs = e.target.value;
    if (this.state.initialValues.rentalLogic.slabs.length < e.target.value) {
      var toAppend =
        e.target.value - this.state.initialValues.rentalLogic.slabs.length;
      for (var i = 0; i < toAppend; i++) {
        this.state.initialValues.rentalLogic.slabs.push({
          from: "",
          to: "",
          percent: "",
          product: "",
        });
      }
    } else if (
      this.state.initialValues.rentalLogic.slabs.length > e.target.value
    ) {
      var toRemove =
        this.state.initialValues.rentalLogic.slabs.length - e.target.value;
      for (var i = 0; i < toRemove; i++) {
        this.state.initialValues.rentalLogic.slabs.pop({});
      }
    }
  };

  getFromForNextSlab(e, values, index) {
    this.state.initialValues.rentalLogic.slabs[index + 1].from =
      Number(e.target.value) + Number(1);
    this.setState({});
  }

  handleRentalLogicChange = (event, values) => {
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    values.rentalLogic.rentalUom = "";
    if (event.target.value === "") {
      this.state.showAddBtn = false;
    } else {
      this.state.showAddBtn = true;
    }
    let index = event.nativeEvent.target.selectedIndex;
    let label = event.nativeEvent.target[index].label;
    this.state.initialValues.rentalLogic.rentalLogicText = label;
    this.state.initialValues.rentalLogic.rentalLogicValue = event.target.value;
    let checkValue = label.includes("Minus CAM");
    if (checkValue) {
      this.setState({
        showMinusCam: true,
      });
    } else {
      this.setState({
        showMinusCam: false,
      });
    }
    if (event.target.value === "1" || event.target.value === "2") {
      this.setState({
        rentMinusCam: true,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "3" || event.target.value === "4") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: true,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "5" || event.target.value === "6") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: true,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "7" || event.target.value === "8") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: true,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "9" || event.target.value === "10") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: true,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "11" || event.target.value === "12") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: true,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      event.target.value === "13" ||
      event.target.value === "14" ||
      event.target.value === "15"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: true,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "16" || event.target.value === "17") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: true,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "18" || event.target.value === "19") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: true,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "20" || event.target.value === "21") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: true,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "22" || event.target.value === "23") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: true,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      event.target.value === "24" ||
      event.target.value === "25" ||
      event.target.value === "26" ||
      event.target.value === "27"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: true,
      });
    } else {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    }
  };

  componentDidMount() {

    let athis = this;
    axios.get(`${apiUrl.apiUrl.url}/lease-view/lease-details-view?leaseId=${this.props.match.params.id}`).then((response) => {
      let data = response.data;
      athis.setState({
        leaseData: data.data,
      });
    }).catch((error) => {});
    
    // fetch(
    //   `${apiUrl.apiUrl.url}/lease-view/lease-details-view?leaseId=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.setState({
    //       leaseData: data.data,
    //     });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    
      
    fetch(
      `${apiUrl.apiUrl.url}/create-lease/fetch-discount-rent?id=${this.props.match.params.id}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.totalGla = data.total_gla;
        // this.state.isRentAutocalculate = data.isRentAutocalculate;
        // this.state.isUnitBifurcate = data.isUnitBifurcate;
        // if (data.isRentAutocalculate) {
        //   this.setState({ isRentCheckboxChecked: true });
        // } else {
        //   this.setState({ isRentCheckboxChecked: false });
        // }
        this.state.to = data.to;
        this.state.fromDate = data.from;
        if (data.rentalDetails.length > 0) {
          if (
            data.rentalDetails[data.rentalDetails.length - 1].toDate == data.to
          ) {
            this.setState({
              showForm: false,
            });
          }

          this.setState({
            fromDate: getToDate(
              data.rentalDetails[data.rentalDetails.length - 1].toDate,
              2,
              0,
              0
            ),
          });
        }
        this.setState(
          {
            // initialValues: data,
            rentalDetails: data.rentalDetails,
          },
          () => {
            console.log(this.state.initialValues);
          }
        );
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/product-master/get-all-products`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          products: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  calculateToDate(values) {
    this.setState({
      toDate: getToDate(
        this.state.fromDate,
        this.state.periodTermDD,
        Number(this.state.periodTermMM),
        this.state.periodTermYY
      ),
    });
  }

  // calculateRentRate(e, values, setFieldValue) {
  //   if (this.state.period > 1) {
  //     setFieldValue(
  //       "rentalLogic.rentRate",
  //       (
  //         Number(
  //           this.state.rentalDetails[this.state.rentalDetails.length - 1]
  //             .rentRate
  //         ) *
  //         (1 + Number(e.target.value) / 100)
  //       ).toFixed(2)
  //     );
  //   }
  // }

  calculateEscalationPercent(e, values, setFieldValue) {
    if (this.state.period > 1) {
      setFieldValue(
        "rentalLogic.escalationPercent",
        (
          ((Number(e.target.value) -
            Number(
              this.state.rentalDetails[this.state.rentalDetails.length - 1]
                .rentRate
            )) /
            Number(
              this.state.rentalDetails[this.state.rentalDetails.length - 1]
                .rentRate
            )) *
          100
        ).toFixed(2)
      );
    }
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  redirectToDelete = () => {
    var _rentals = this.state.rentalDetails;
    _rentals.splice(this.state.index_val, 1);

    this.setState({
      rentalDetails: _rentals,
      showForm: true,
    });
    this.state.period--;

    if (this.state.rentalDetails.length > 0) {
      this.setState({
        fromDate: getToDate(
          this.state.rentalDetails[this.state.rentalDetails.length - 1].toDate,
          2,
          0,
          0
        ),
      });
    } else {
      this.setState({
        fromDate: this.state.revalue,
      });
    }
    this.setState({
      delete: false,
      index_val: "",
      revalue: "",
    });
  };

  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return (
        <Redirect
          push
          to={"/createlease/cam-details/" + this.props.match.params.id}
        />
      );
    }
    return (
      <div
        className="parentContainer createLease">
        <div>
          <div>
            <div className="absoluteItemForTopBar">
              <div className="new_breadcrumbs_design">
                <ul className="d-flex align-items-center gap-3 p-0 m-0">
                  <li>Create Lease</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>
                    <a href="#">Waiver</a>
                  </li>
                </ul>
              </div>
            </div>


            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values, actions) => {
                // if (this.state.rentalDetails.length == 0) {
                //   this.mainFormValidator.showMessages("countError");
                //   return false;
                // }

                // if (
                //   this.state.to !==
                //   this.state.rentalDetails[this.state.rentalDetails.length - 1]
                //     .toDate
                // ) {
                //   this.setState({
                //     popupalertMessage: true,
                //     popupMessageContent: "Please Complete the period",
                //   });
                //   return false;
                // }

                values.rentalDetails = this.state.rentalDetails;

                var self = this;
                axios({
                  method: "post",
                  url: `${apiUrl.apiUrl.url}/create-lease/update-discount-rent?lease_id=${this.props.match.params.id}`,
                  data: values,
                }).then(function (response) {
                  if (!response.data.success) {
                    actions.setSubmitting(false);
                    actions.setErrors(response.data);
                  } else {
                    self.setState({ messsagePopup: true });
                  }
                });
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
                resetForm,
                setFieldValue,
              }) => (
                <Form autoComplete="off" className="customTabs">
                  <div className="unitFormContainer mb-4">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-6 mx-auto">
                          <div className="tableContainer prospectTable mt-0">
                            <table className="table tableSimple tableSimpleWithNoFlex">
                              <tbody>
                                <tr>
                                  <th
                                    scope="col"
                                    style={{
                                      backgroundColor: "#005b9b",
                                      color: "#fff",
                                      borderRight: "1px solid #fff",
                                      textAlign: "center",
                                    }}
                                  >
                                    Lease No
                                  </th>
                                  <td
                                    style={{
                                      backgroundColor: "#005b9b",
                                      color: "#fff",
                                    }}
                                  >
                                    {this.state.leaseData.lease_code}
                                  </td>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                    style={{
                                      backgroundColor: "#005b9b",
                                      color: "#fff",
                                      borderRight: "1px solid #fff",
                                      textAlign: "center",
                                    }}
                                  >
                                    Cost Center
                                  </th>
                                  <td
                                    style={{
                                      backgroundColor: "#005b9b",
                                      color: "#fff",
                                    }}
                                  >
                                    {this.state.leaseData.cost_center}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      {this.state.showForm && (
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">
                                  Rental Logic <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-10 logicDropdownWidthDesktop">
                                  <Field
                                    as="select"
                                    name={"rentalLogic.rentalLogicValue"}
                                    // disabled={this.state.disableOnEdit}
                                    value={
                                      this.state.initialValues.rentalLogic
                                        .rentalLogicValue
                                    }
                                    onChange={(e) => {
                                      handleChange(e);
                                      this.handleRentalLogicChange(e, values);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option value="1" label="Rent Only" />
                                    {/* <option
                                      value="2"
                                      label="Rent Minus CAM (%)"
                                    /> */}
                                    {/* <option
                                      value="3"
                                      label="Rent Plus Fitout Rent"
                                    />
                                    <option
                                      value="4"
                                      label="Rent Plus Fitout Rent Minus CAM (%)"
                                    /> */}
                                    {this.state.isRentAutocalculate ===
                                      false && (
                                        <>
                                          {/* <option
                                          value="5"
                                          label="Pure Revenue Share"
                                        /> */}
                                          {/* <option
                                          value="6"
                                          label="Pure Revenue Share Minus CAM (%)"
                                        />
                                        <option
                                          value="7"
                                          label="Pure Revenue Share Sales Range"
                                        />
                                        <option
                                          value="8"
                                          label="Pure Revenue Share Sales Range Minus CAM (%)"
                                        />
                                        <option
                                          value="9"
                                          label="Pure Revenue Share Product Category"
                                        />
                                        <option
                                          value="10"
                                          label="Pure Revenue Share Product Category Minus CAM (%)"
                                        />
                                        <option
                                          value="11"
                                          label="Pure Revenue Share Sales Range Product Category"
                                        />
                                        <option
                                          value="12"
                                          label="Pure Revenue Share Sales Range Product Category Minus CAM (%)"
                                        />
                                        <option
                                          value="13"
                                          label="Minimum Guarantee Rent or Revenue Share (Higher)"
                                        />
                                        <option
                                          value="14"
                                          label="Minimum Guarantee Rent or Revenue Share (Higher) Minus CAM (%)"
                                        />
                                        <option
                                          value="15"
                                          label="Minimum Guarantee (Rent + CAM) or Revenue Share (Higher)"
                                        />
                                        <option
                                          value="16"
                                          label="Minimum Guarantee (Rent + Fitout Rent) or Revenue Share (Higher)"
                                        />
                                        <option
                                          value="17"
                                          label="Minimum Guarantee (Rent + Fitout Rent) or Revenue Share (Higher)  Minus CAM (%)"
                                        />
                                        <option
                                          value="18"
                                          label="Minimum Guarantee Rent or Revenue Share Sales Range (Higher)"
                                        />
                                        <option
                                          value="19"
                                          label="Minimum Guarantee Rent or Revenue Share Sales Range (Higher) Minus CAM (%)"
                                        />
                                        <option
                                          value="20"
                                          label="Minimum Guarantee Rent or Revenue Share Product Category (Higher)"
                                        />
                                        <option
                                          value="21"
                                          label="Minimum Guarantee Rent or Revenue Share Product Category (Higher) Minus CAM (%)"
                                        />
                                        <option
                                          value="22"
                                          label="Minimum Guarantee Rent or Revenue Share Sales Range and Product Category (Higher)"
                                        />
                                        <option
                                          value="23"
                                          label="Minimum Guarantee Rent or Revenue Share Sales Range and Product Category (Higher) Minus CAM (%)"
                                        />
                                        <option
                                          value="24"
                                          label="Minimum Guarantee Rent and Revenue Share (Both)"
                                        />
                                        <option
                                          value="25"
                                          label="Minimum Guarantee Rent and Revenue Share (Both) Minus CAM (%)"
                                        />
                                        <option
                                          value="26"
                                          label="Minimum Guarantee Rent and Revenue Share (Lower)"
                                        />
                                        <option
                                          value="27"
                                          label="Minimum Guarantee Rent and Revenue Share (Lower) Minus CAM (%)"
                                        /> */}
                                        </>
                                      )}
                                  </Field>
                                  {/* {this.validator.message(
                                    "Rental Logic",
                                    this.state.initialValues.rentalLogic
                                      .rentalLogicValue,
                                    "required",
                                    { className: "text-danger" }
                                  )} */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {this.state.rentMinusCam && (
                        <div className="rentMinusCam">
                          <div className="row">
                            {this.state.isRentAutocalculate === false && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      From <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="date"
                                        name="rentalLogic.fromDate"
                                        // readOnly={true}
                                        value={this.state.fromDate}
                                        onChange={(e) => {
                                          this.setState({
                                            fromDate: e.target.value,
                                          });
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.isRentAutocalculate === false && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      To <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="date"
                                        // readOnly={true}
                                        name="rentalLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => {
                                          this.setState({
                                            toDate: e.target.value,
                                          });
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent UOM <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentalUom"}
                                      onChange={(e) => {
                                        this.validator =
                                          new SimpleReactValidator({
                                            autoForceUpdate: this,
                                          });
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Sq Ft"
                                        label="Per Sq Ft"
                                      />
                                      <option
                                        value="Flat Amount"
                                        label="Flat Amount"
                                      />
                                    </Field>
                                    {this.validator.message(
                                      "Rent UOM",
                                      values.rentalLogic.rentalUom,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {values.rentalLogic.rentalUom == "Per Sq Ft" && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      On Area
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.onArea"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Usable Area"
                                          label="Usable Area"
                                        />
                                        <option
                                          value="Carpet Area"
                                          label="Carpet Area"
                                        />
                                        <option
                                          value="Gross Leasable Area"
                                          label="Gross Leasable Area"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "On Area",
                                        values.rentalLogic.onArea,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.period > 1 &&
                              this.state.isRentAutocalculate === false && (
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Escalation %
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="number"
                                          name="rentalLogic.escalationPercent"
                                          disabled={this.state.disableOnEdit}
                                          onBlur={(e) => {
                                            this.calculateRentRate(
                                              e,
                                              values,
                                              setFieldValue
                                            );
                                          }}
                                        />
                                        {this.validator.message(
                                          "Escalation %",
                                          values.rentalLogic.escalationPercent,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Rate
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentRate"
                                      onBlur={(e) => {
                                        this.calculateEscalationPercent(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "rent Rate",
                                      values.rentalLogic.rentRate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Rate Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentRateTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "rent Rate Term",
                                      values.rentalLogic.rentRateTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "rent Frequency",
                                      values.rentalLogic.rentFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Due Date
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "rent Due Date",
                                      values.rentalLogic.rentDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {this.state.showMinusCam && (
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Minus CAM %{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="rentalLogic.minusCamPercent"
                                      />
                                      {this.validator.message(
                                        "Minus CAM %",
                                        values.rentalLogic.minusCamPercent,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {this.state.rentFitoutMinusCam && (
                        <div className="rentFitoutMinusCam">
                          <div className="row">
                            {this.state.isRentAutocalculate === false && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      From <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="date"
                                        name="rentalLogic.fromDate"
                                        readOnly={this.state.readOnEdit}
                                        value={this.state.fromDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.isRentAutocalculate === false && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      To <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="date"
                                        readOnly={this.state.readOnEdit}
                                        name="rentalLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => {
                                          console.log(e.target.value);
                                          this.setState({
                                            toDate: e.target.value,
                                          });
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent UOM <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentalUom"}
                                      onChange={(e) => {
                                        this.validator =
                                          new SimpleReactValidator({
                                            autoForceUpdate: this,
                                          });
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Sq Ft"
                                        label="Per Sq Ft"
                                      />
                                      <option
                                        value="Flat Amount"
                                        label="Flat Amount"
                                      />
                                    </Field>
                                    {this.validator.message(
                                      "Rent UOM",
                                      values.rentalLogic.rentalUom,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {values.rentalLogic.rentalUom == "Per Sq Ft" && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      On Area
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.onArea"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Usable Area"
                                          label="Usable Area"
                                        />
                                        <option
                                          value="Carpet Area"
                                          label="Carpet Area"
                                        />
                                        <option
                                          value="Gross Leasable Area"
                                          label="Gross Leasable Area"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "On Area",
                                        values.rentalLogic.onArea,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.period > 1 &&
                              this.state.isRentAutocalculate === false && (
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Escalation %
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="number"
                                          name="rentalLogic.escalationPercent"
                                          disabled={this.state.disableOnEdit}
                                          onBlur={(e) => {
                                            this.calculateRentRate(
                                              e,
                                              values,
                                              setFieldValue
                                            );
                                          }}
                                        />
                                        {this.validator.message(
                                          "Escalation %",
                                          values.rentalLogic.escalationPercent,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Rate
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentRate"
                                      onBlur={(e) => {
                                        this.calculateEscalationPercent(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "rent Rate",
                                      values.rentalLogic.rentRate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Rate Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentRateTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "rent Rate Term",
                                      values.rentalLogic.rentRateTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "rent Frequency",
                                      values.rentalLogic.rentFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Due Date
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "rent Due Date",
                                      values.rentalLogic.rentDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row rentFitout mb-3">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Fitout Rate UOM{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.fitoutUom"}
                                      onChange={(e) => {
                                        this.validator =
                                          new SimpleReactValidator({
                                            autoForceUpdate: this,
                                          });
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Sq Ft"
                                        label="Per Sq Ft"
                                      />
                                      <option
                                        value="Flat Amount"
                                        label="Flat Amount"
                                      />
                                    </Field>
                                    {this.validator.message(
                                      "fitout Uom",
                                      values.rentalLogic.fitoutUom,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {values.rentalLogic.fitoutUom == "Per Sq Ft" && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Fitout On Area
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.fitoutOnArea"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Usable Area"
                                          label="Usable Area"
                                        />
                                        <option
                                          value="Carpet Area"
                                          label="Carpet Area"
                                        />
                                        <option
                                          value="Gross Leasable Area"
                                          label="Gross Leasable Area"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "Fitout On Area",
                                        values.rentalLogic.fitoutOnArea,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Fitout Rate
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="number"
                                      name="rentalLogic.fitoutRate"
                                    />
                                    <ErrorMessage
                                      name="rentalLogic.fitoutRate"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Fitout Rate Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.fitoutRateTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "Rate Term",
                                      values.rentalLogic.fitoutRateTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Fitout Rent Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.fitoutFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "fitout Frequency",
                                      values.rentalLogic.fitoutFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {this.state.showMinusCam && (
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Minus CAM %{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="rentalLogic.minusCamPercent"
                                      />
                                      {this.validator.message(
                                        "Minus CAM %",
                                        values.rentalLogic.minusCamPercent,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {this.state.pureRevenueShareMinusCam && (
                        <div className="pureRevenue">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    From <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.fromDate"
                                      value={this.state.fromDate}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "From",
                                      this.state.fromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    To <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.toDate"
                                      value={this.state.toDate}
                                      onChange={(e) => {
                                        console.log(e.target.value);
                                        this.setState({
                                          toDate: e.target.value,
                                        });
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "To",
                                      this.state.toDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row revenueShareRow">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share (%){" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="number"
                                      name="rentalLogic.revenueShare"
                                    />
                                    {this.validator.message(
                                      "Revenue Share %",
                                      values.rentalLogic.revenueShare,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Term",
                                      values.rentalLogic.revenueShareTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Frequency",
                                      values.rentalLogic.revenueShareFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Due Date{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    ></Field>
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "Revenue Share Due Date",
                                      values.rentalLogic.revenueShareDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Reconcilitation
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={
                                        "rentalLogic.revenueShareReconcilitation"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Reconcilitation",
                                      values.rentalLogic
                                        .revenueShareReconcilitation,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {this.state.showMinusCam && (
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Minus CAM %{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="rentalLogic.minusCamPercent"
                                      />
                                      {this.validator.message(
                                        "Minus CAM %",
                                        values.rentalLogic.minusCamPercent,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {this.state.pureRevenueSalesShareMinusCam && (
                        <div className="pureRevenueSales">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    From <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.fromDate"
                                      value={this.state.fromDate}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "From",
                                      this.state.fromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    To <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.toDate"
                                      value={this.state.toDate}
                                      onChange={(e) => {
                                        console.log(e.target.value);
                                        this.setState({
                                          toDate: e.target.value,
                                        });
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "To",
                                      this.state.toDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row revenueShareRow">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Term",
                                      values.rentalLogic.revenueShareTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Frequency",
                                      values.rentalLogic.revenueShareFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Due Date{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    ></Field>
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "Revenue Share Due Date",
                                      values.rentalLogic.revenueShareDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Applicability
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={
                                        "rentalLogic.revenueShareApplicability"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="cumulative"
                                        label="Cumulative"
                                      />
                                      <option
                                        value="incremental"
                                        label="Incremental"
                                      />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Applicability",
                                      values.rentalLogic
                                        .revenueShareApplicability,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Reconcilitation
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={
                                        "rentalLogic.revenueShareReconcilitation"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Reconcilitation",
                                      values.rentalLogic
                                        .revenueShareReconcilitation,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-2 col-form-label">
                                    Revenue Share (%)
                                  </label>
                                  <div className="col-sm-10 slabWidthDesktop">
                                    <div className="tableContainer">
                                      <div className="col-lg-6 mb-4">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-3 col-form-label">
                                              No. of SLABS{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="text"
                                                name="rentalLogic.slabNumber"
                                                value={
                                                  this.state.initialValues
                                                    .totalSlabs
                                                }
                                                className="slabInput"
                                                onChange={(e) => {
                                                  this.addSlabRow(e);
                                                  handleChange(e);
                                                }}
                                              />
                                              <ErrorMessage
                                                name="rentalLogic.slabNumber"
                                                component="div"
                                                className="text-red"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <table className="table tableSimple">
                                        <thead>
                                          <tr>
                                            <th scope="col">SLAB</th>
                                            <th scope="col">FROM</th>
                                            <th scope="col">To</th>
                                            <th scope="col">
                                              Revenue Share (%)
                                            </th>
                                            <th scope="col" colSpan="">
                                              Action
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {this.state.initialValues.rentalLogic
                                            .slabs.length > 0 &&
                                            this.state.initialValues.rentalLogic.slabs.map(
                                              (friend, index) => (
                                                <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`rentalLogic.slabs.${index}.from`}
                                                      onChange={(e) => {
                                                        console.log(
                                                          e.target.value
                                                        );
                                                        this.state.initialValues.rentalLogic.slabs[
                                                          index
                                                        ].from = e.target.value;
                                                        handleChange(e);
                                                      }}
                                                      value={
                                                        this.state.initialValues
                                                          .rentalLogic.slabs[
                                                          index
                                                        ].from
                                                      }
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`rentalLogic.slabs.${index}.to`}
                                                      onChange={(e) => {
                                                        this.state.initialValues.rentalLogic.slabs[
                                                          index
                                                        ].to = e.target.value;
                                                        handleChange(e);
                                                      }}
                                                      value={
                                                        this.state.initialValues
                                                          .rentalLogic.slabs[
                                                          index
                                                        ].to
                                                      }
                                                      onBlur={(e) => {
                                                        if (
                                                          index <
                                                          this.state
                                                            .initialValues
                                                            .rentalLogic.slabs
                                                            .length -
                                                          1
                                                        ) {
                                                          this.getFromForNextSlab(
                                                            e,
                                                            values,
                                                            index
                                                          );
                                                        }
                                                      }}
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`rentalLogic.slabs.${index}.percent`}
                                                      onChange={(e) => {
                                                        this.state.initialValues.rentalLogic.slabs[
                                                          index
                                                        ].percent =
                                                          e.target.value;
                                                        handleChange(e);
                                                      }}
                                                      value={
                                                        this.state.initialValues
                                                          .rentalLogic.slabs[
                                                          index
                                                        ].percent
                                                      }
                                                    />
                                                  </td>

                                                  <td>
                                                    <a
                                                      className="actionDelete"
                                                      href="#"
                                                      onClick={(e) => {
                                                        this.state.initialValues
                                                          .totalSlabs--;
                                                        var _slabs =
                                                          this.state
                                                            .initialValues
                                                            .rentalLogic.slabs;
                                                        _slabs.splice(index, 1);
                                                        this.setState({
                                                          slabs: _slabs,
                                                        });
                                                      }}
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faTimes}
                                                      />
                                                    </a>
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {this.state.showMinusCam && (
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Minus CAM %{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="rentalLogic.minusCamPercent"
                                      />
                                      {this.validator.message(
                                        "Minus CAM %",
                                        values.rentalLogic.minusCamPercent,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {this.state.pureRevenueProduct && (
                        <div className="pureRevenueProduct">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    From <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.fromDate"
                                      value={this.state.fromDate}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "From",
                                      this.state.fromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    To <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.toDate"
                                      value={this.state.toDate}
                                      onChange={(e) => {
                                        console.log(e.target.value);
                                        this.setState({
                                          toDate: e.target.value,
                                        });
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "To",
                                      this.state.toDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row revenueShareRow">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Term",
                                      values.rentalLogic.revenueShareTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Frequency",
                                      values.rentalLogic.revenueShareFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Due Date{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    ></Field>
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "Revenue Share Due Date",
                                      values.rentalLogic.revenueShareDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Applicability
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={
                                        "rentalLogic.revenueShareApplicability"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="cumulative"
                                        label="Cumulative"
                                      />
                                      <option
                                        value="incremental"
                                        label="Incremental"
                                      />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Applicability",
                                      values.rentalLogic
                                        .revenueShareApplicability,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Reconcilitation
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={
                                        "rentalLogic.revenueShareReconcilitation"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Reconcilitation",
                                      values.rentalLogic
                                        .revenueShareReconcilitation,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-2 col-form-label">
                                    Revenue Share (%)
                                  </label>
                                  <div className="col-sm-10 slabWidthDesktop">
                                    <div className="tableContainer">
                                      <div className="col-lg-6 mb-4">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-3 col-form-label">
                                              No. of Products{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="text"
                                                name="rentalLogic.slabNumber"
                                                value={
                                                  this.state.initialValues
                                                    .totalSlabs
                                                }
                                                className="slabInput"
                                                onChange={(e) => {
                                                  this.addSlabRow(e);
                                                  handleChange(e);
                                                }}
                                              />
                                              <ErrorMessage
                                                name="rentalLogic.slabNumber"
                                                component="div"
                                                className="text-red"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <table className="table tableSimple">
                                        <thead>
                                          <tr>
                                            <th scope="col">SLAB</th>
                                            <th scope="col">PRODUCT</th>
                                            <th scope="col">
                                              Revenue Share (%)
                                            </th>
                                            <th scope="col" colSpan="">
                                              Action
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {this.state.initialValues.rentalLogic
                                            .slabs.length > 0 &&
                                            this.state.initialValues.rentalLogic.slabs.map(
                                              (friend, index) => (
                                                <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td>
                                                    <Select
                                                      className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                                      isSearchable="true"
                                                      name={`rentalLogic.slabs.${index}.product`}
                                                      value={{
                                                        label:
                                                          this.state
                                                            .initialValues
                                                            .rentalLogic.slabs[
                                                            index
                                                          ].productName,
                                                        value:
                                                          this.state
                                                            .initialValues
                                                            .rentalLogic.slabs[
                                                            index
                                                          ].product,
                                                      }}
                                                      onChange={(e) => {
                                                        this.changeProduct(
                                                          e,
                                                          values,
                                                          index
                                                        );
                                                      }}
                                                      options={this.state.products.map(
                                                        (item) => ({
                                                          label:
                                                            item.product_name,
                                                          value: item.id,
                                                        })
                                                      )}
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`rentalLogic.slabs.${index}.percent`}
                                                      onChange={(e) => {
                                                        this.state.initialValues.rentalLogic.slabs[
                                                          index
                                                        ].percent =
                                                          e.target.value;
                                                        handleChange(e);
                                                      }}
                                                      value={
                                                        this.state.initialValues
                                                          .rentalLogic.slabs[
                                                          index
                                                        ].percent
                                                      }
                                                    />
                                                  </td>
                                                  <td>
                                                    <a
                                                      className="actionDelete"
                                                      href="#"
                                                      onClick={(e) => {
                                                        this.state.initialValues
                                                          .totalSlabs--;
                                                        var _slabs =
                                                          this.state
                                                            .initialValues
                                                            .rentalLogic.slabs;
                                                        _slabs.splice(index, 1);
                                                        this.setState({
                                                          slabs: _slabs,
                                                        });
                                                      }}
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faTimes}
                                                      />
                                                    </a>
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {this.state.showMinusCam && (
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Minus CAM %{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="rentalLogic.minusCamPercent"
                                      />
                                      {this.validator.message(
                                        "Minus CAM %",
                                        values.rentalLogic.minusCamPercent,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {this.state.pureRevenueSalesProduct && (
                        <div className="pureRevenueSalesProduct">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    From <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.fromDate"
                                      value={this.state.fromDate}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "From",
                                      this.state.fromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    To <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.toDate"
                                      value={this.state.toDate}
                                      onChange={(e) => {
                                        console.log(e.target.value);
                                        this.setState({
                                          toDate: e.target.value,
                                        });
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "To",
                                      this.state.toDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row revenueShareRow">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Term",
                                      values.rentalLogic.revenueShareTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Frequency",
                                      values.rentalLogic.revenueShareFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Due Date{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    ></Field>
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "Revenue Share Due Date",
                                      values.rentalLogic.revenueShareDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Applicability
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={
                                        "rentalLogic.revenueShareApplicability"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="cumulative"
                                        label="Cumulative"
                                      />
                                      <option
                                        value="incremental"
                                        label="Incremental"
                                      />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Applicability",
                                      values.rentalLogic
                                        .revenueShareApplicability,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Reconcilitation
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={
                                        "rentalLogic.revenueShareReconcilitation"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Reconcilitation",
                                      values.rentalLogic
                                        .revenueShareReconcilitation,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-2 col-form-label">
                                    Revenue Share (%)
                                  </label>
                                  <div className="col-sm-10 slabWidthDesktop">
                                    <div className="tableContainer">
                                      <div className="col-lg-6 mb-4">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-3 col-form-label">
                                              No. of Products & Sales Slabs
                                              <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="text"
                                                name="rentalLogic.slabNumber"
                                                value={
                                                  this.state.initialValues
                                                    .totalSlabs
                                                }
                                                className="slabInput"
                                                onChange={(e) => {
                                                  this.addSlabRow(e);
                                                  handleChange(e);
                                                }}
                                              />
                                              <ErrorMessage
                                                name="rentalLogic.slabNumber"
                                                component="div"
                                                className="text-red"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <table className="table tableSimple">
                                        <thead>
                                          <tr>
                                            <th scope="col">SLAB</th>
                                            <th scope="col">PRODUCT</th>
                                            <th scope="col">FROM</th>
                                            <th scope="col">TO</th>
                                            <th scope="col">
                                              Revenue Share (%)
                                            </th>
                                            <th scope="col" colSpan="">
                                              Action
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {this.state.initialValues.rentalLogic
                                            .slabs.length > 0 &&
                                            this.state.initialValues.rentalLogic.slabs.map(
                                              (friend, index) => (
                                                <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td
                                                    style={{ width: "200px" }}
                                                  >
                                                    <Select
                                                      className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                                      isSearchable="true"
                                                      name={`rentalLogic.slabs.${index}.product`}
                                                      value={{
                                                        label:
                                                          this.state
                                                            .initialValues
                                                            .rentalLogic.slabs[
                                                            index
                                                          ].productName,
                                                        value:
                                                          this.state
                                                            .initialValues
                                                            .rentalLogic.slabs[
                                                            index
                                                          ].product,
                                                      }}
                                                      onChange={(e) => {
                                                        this.changeProduct(
                                                          e,
                                                          values,
                                                          index
                                                        );
                                                      }}
                                                      options={this.state.products.map(
                                                        (item) => ({
                                                          label:
                                                            item.product_name,
                                                          value: item.id,
                                                        })
                                                      )}
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`rentalLogic.slabs.${index}.from`}
                                                      onChange={(e) => {
                                                        console.log(
                                                          e.target.value
                                                        );
                                                        this.state.initialValues.rentalLogic.slabs[
                                                          index
                                                        ].from = e.target.value;
                                                        handleChange(e);
                                                      }}
                                                      value={
                                                        this.state.initialValues
                                                          .rentalLogic.slabs[
                                                          index
                                                        ].from
                                                      }
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`rentalLogic.slabs.${index}.to`}
                                                      onChange={(e) => {
                                                        console.log(
                                                          e.target.value
                                                        );
                                                        this.state.initialValues.rentalLogic.slabs[
                                                          index
                                                        ].to = e.target.value;
                                                        handleChange(e);
                                                      }}
                                                      value={
                                                        this.state.initialValues
                                                          .rentalLogic.slabs[
                                                          index
                                                        ].to
                                                      }
                                                      onBlur={(e) => {
                                                        if (
                                                          index <
                                                          this.state
                                                            .initialValues
                                                            .rentalLogic.slabs
                                                            .length -
                                                          1
                                                        ) {
                                                          this.getFromForNextSlab(
                                                            e,
                                                            values,
                                                            index
                                                          );
                                                        }
                                                      }}
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`rentalLogic.slabs.${index}.percent`}
                                                      onChange={(e) => {
                                                        console.log(
                                                          e.target.value
                                                        );
                                                        this.state.initialValues.rentalLogic.slabs[
                                                          index
                                                        ].percent =
                                                          e.target.value;
                                                        handleChange(e);
                                                      }}
                                                      value={
                                                        this.state.initialValues
                                                          .rentalLogic.slabs[
                                                          index
                                                        ].percent
                                                      }
                                                    />
                                                  </td>
                                                  {/* <td>
                                                        <a
                                                          className="actionAdd"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPlus}
                                                          />
                                                        </a>
                                                      </td>
                                                      <td>
                                                        <a
                                                          className="actionEdit"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPen}
                                                          />
                                                        </a>
                                                      </td> */}
                                                  <td>
                                                    <a
                                                      className="actionDelete"
                                                      href="#"
                                                      onClick={(e) => {
                                                        this.state.initialValues
                                                          .totalSlabs--;
                                                        var _slabs =
                                                          this.state
                                                            .initialValues
                                                            .rentalLogic.slabs;
                                                        _slabs.splice(index, 1);
                                                        this.setState({
                                                          slabs: _slabs,
                                                        });
                                                      }}
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faTimes}
                                                      />
                                                    </a>
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {this.state.showMinusCam && (
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Minus CAM %{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="rentalLogic.minusCamPercent"
                                      />
                                      {this.validator.message(
                                        "Minus CAM %",
                                        values.rentalLogic.minusCamPercent,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {this.state.minimumGuaranteeRentPlusCam && (
                        <div className="minimumGuaranteeRentPlusCam">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    From <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.fromDate"
                                      value={this.state.fromDate}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "From",
                                      this.state.fromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    To <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.toDate"
                                      value={this.state.toDate}
                                      onChange={(e) => {
                                        console.log(e.target.value);
                                        this.setState({
                                          toDate: e.target.value,
                                        });
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "To",
                                      this.state.toDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent UOM <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentalUom"}
                                      onChange={(e) => {
                                        this.validator =
                                          new SimpleReactValidator({
                                            autoForceUpdate: this,
                                          });
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Sq Ft"
                                        label="Per Sq Ft"
                                      />
                                      <option
                                        value="Flat Amount"
                                        label="Flat Amount"
                                      />
                                    </Field>
                                    {this.validator.message(
                                      "Rent UOM",
                                      values.rentalLogic.rentalUom,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {values.rentalLogic.rentalUom == "Per Sq Ft" && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      On Area
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.onArea"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Usable Area"
                                          label="Usable Area"
                                        />
                                        <option
                                          value="Carpet Area"
                                          label="Carpet Area"
                                        />
                                        <option
                                          value="Gross Leasable Area"
                                          label="Gross Leasable Area"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "On Area",
                                        values.rentalLogic.onArea,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.period > 1 &&
                              this.state.isRentAutocalculate === false && (
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Escalation %
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="number"
                                          name="rentalLogic.escalationPercent"
                                          disabled={this.state.disableOnEdit}
                                          onBlur={(e) => {
                                            this.calculateRentRate(
                                              e,
                                              values,
                                              setFieldValue
                                            );
                                          }}
                                        />
                                        {this.validator.message(
                                          "Escalation %",
                                          values.rentalLogic.escalationPercent,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Rate
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentRate"
                                      onBlur={(e) => {
                                        this.calculateEscalationPercent(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "rent Rate",
                                      values.rentalLogic.rentRate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Rate Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentRateTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "rent Rate Term",
                                      values.rentalLogic.rentRateTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "rent Frequency",
                                      values.rentalLogic.rentFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Due Date
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "rent Due Date",
                                      values.rentalLogic.rentDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row revenueShareRow">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share (%){" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="number"
                                      name="rentalLogic.revenueShare"
                                    />
                                    {this.validator.message(
                                      "Revenue Share %",
                                      values.rentalLogic.revenueShare,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Term",
                                      values.rentalLogic.revenueShareTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Frequency",
                                      values.rentalLogic.revenueShareFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Due Date{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    ></Field>
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "Revenue Share Due Date",
                                      values.rentalLogic.revenueShareDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Reconcilitation
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={
                                        "rentalLogic.revenueShareReconcilitation"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Reconcilitation",
                                      values.rentalLogic
                                        .revenueShareReconcilitation,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {this.state.showMinusCam && (
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Minus CAM %{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="rentalLogic.minusCamPercent"
                                      />
                                      {this.validator.message(
                                        "Minus CAM %",
                                        values.rentalLogic.minusCamPercent,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {this.state.minimumGuaranteeRentPlusFitout && (
                        <div className="minimumGuaranteeRentPlusFitout">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    From <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.fromDate"
                                      value={this.state.fromDate}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "From",
                                      this.state.fromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    To <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.toDate"
                                      value={this.state.toDate}
                                      onChange={(e) => {
                                        console.log(e.target.value);
                                        this.setState({
                                          toDate: e.target.value,
                                        });
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "To",
                                      this.state.toDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent UOM <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentalUom"}
                                      onChange={(e) => {
                                        this.validator =
                                          new SimpleReactValidator({
                                            autoForceUpdate: this,
                                          });
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Sq Ft"
                                        label="Per Sq Ft"
                                      />
                                      <option
                                        value="Flat Amount"
                                        label="Flat Amount"
                                      />
                                    </Field>
                                    {this.validator.message(
                                      "Rent UOM",
                                      values.rentalLogic.rentalUom,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {values.rentalLogic.rentalUom == "Per Sq Ft" && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      On Area
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.onArea"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Usable Area"
                                          label="Usable Area"
                                        />
                                        <option
                                          value="Carpet Area"
                                          label="Carpet Area"
                                        />
                                        <option
                                          value="Gross Leasable Area"
                                          label="Gross Leasable Area"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "On Area",
                                        values.rentalLogic.onArea,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.period > 1 &&
                              this.state.isRentAutocalculate === false && (
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Escalation %
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="number"
                                          name="rentalLogic.escalationPercent"
                                          disabled={this.state.disableOnEdit}
                                          onBlur={(e) => {
                                            this.calculateRentRate(
                                              e,
                                              values,
                                              setFieldValue
                                            );
                                          }}
                                        />
                                        {this.validator.message(
                                          "Escalation %",
                                          values.rentalLogic.escalationPercent,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Rate
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentRate"
                                      onBlur={(e) => {
                                        this.calculateEscalationPercent(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "rent Rate",
                                      values.rentalLogic.rentRate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Rate Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentRateTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "rent Rate Term",
                                      values.rentalLogic.rentRateTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "rent Frequency",
                                      values.rentalLogic.rentFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Due Date
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "rent Due Date",
                                      values.rentalLogic.rentDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row revenueShareRow">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share (%){" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="number"
                                      name="rentalLogic.revenueShare"
                                    />
                                    {this.validator.message(
                                      "Revenue Share %",
                                      values.rentalLogic.revenueShare,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Term",
                                      values.rentalLogic.revenueShareTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Frequency",
                                      values.rentalLogic.revenueShareFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Due Date{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    ></Field>
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "Revenue Share Due Date",
                                      values.rentalLogic.revenueShareDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Reconcilitation
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={
                                        "rentalLogic.revenueShareReconcilitation"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Reconcilitation",
                                      values.rentalLogic
                                        .revenueShareReconcilitation,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row rentFitout mb-3">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Fitout Rate UOM{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.fitoutUom"}
                                      onChange={(e) => {
                                        this.validator =
                                          new SimpleReactValidator({
                                            autoForceUpdate: this,
                                          });
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Sq Ft"
                                        label="Per Sq Ft"
                                      />
                                      <option
                                        value="Flat Amount"
                                        label="Flat Amount"
                                      />
                                    </Field>

                                    {this.validator.message(
                                      "Fitout Rate UOM",
                                      values.rentalLogic.fitoutUom,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {values.rentalLogic.fitoutUom == "Per Sq Ft" && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Fitout On Area
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.fitoutOnArea"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Usable Area"
                                          label="Usable Area"
                                        />
                                        <option
                                          value="Carpet Area"
                                          label="Carpet Area"
                                        />
                                        <option
                                          value="Gross Leasable Area"
                                          label="Gross Leasable Area"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "Fitout On Area",
                                        values.rentalLogic.fitoutOnArea,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Fitout Rate
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="number"
                                      name="rentalLogic.fitoutRate"
                                    />
                                    <ErrorMessage
                                      name="rentalLogic.fitoutRate"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Fitout Rate Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.fitoutRateTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "Fitout Rate Term",
                                      values.rentalLogic.fitoutRateTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Fitout Rent Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.fitoutFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Fitout Rate Frequency",
                                      values.rentalLogic.fitoutFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {this.state.showMinusCam && (
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Minus CAM %{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="rentalLogic.minusCamPercent"
                                      />
                                      {this.validator.message(
                                        "Minus CAM %",
                                        values.rentalLogic.minusCamPercent,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {this.state
                        .minimumGuaranteeRentRevenueShareSalesRange && (
                          <div className="minimumGuaranteeRentRevenueShareSalesRange">
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      From <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="date"
                                        name="rentalLogic.fromDate"
                                        value={this.state.fromDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      To <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="date"
                                        name="rentalLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => {
                                          console.log(e.target.value);
                                          this.setState({
                                            toDate: e.target.value,
                                          });
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Rent UOM <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.rentalUom"}
                                        onChange={(e) => {
                                          this.validator =
                                            new SimpleReactValidator({
                                              autoForceUpdate: this,
                                            });
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Per Sq Ft"
                                          label="Per Sq Ft"
                                        />
                                        <option
                                          value="Flat Amount"
                                          label="Flat Amount"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "Rent UOM",
                                        values.rentalLogic.rentalUom,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {values.rentalLogic.rentalUom == "Per Sq Ft" && (
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        On Area
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          as="select"
                                          name={"rentalLogic.onArea"}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option
                                            value="Usable Area"
                                            label="Usable Area"
                                          />
                                          <option
                                            value="Carpet Area"
                                            label="Carpet Area"
                                          />
                                          <option
                                            value="Gross Leasable Area"
                                            label="Gross Leasable Area"
                                          />
                                        </Field>
                                        {this.validator.message(
                                          "On Area",
                                          values.rentalLogic.onArea,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {this.state.period > 1 &&
                                this.state.isRentAutocalculate === false && (
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Escalation %
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="rentalLogic.escalationPercent"
                                            disabled={this.state.disableOnEdit}
                                            onBlur={(e) => {
                                              this.calculateRentRate(
                                                e,
                                                values,
                                                setFieldValue
                                              );
                                            }}
                                          />
                                          {this.validator.message(
                                            "Escalation %",
                                            values.rentalLogic.escalationPercent,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Rent Rate
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="number"
                                        name="rentalLogic.rentRate"
                                        onBlur={(e) => {
                                          this.calculateEscalationPercent(
                                            e,
                                            values,
                                            setFieldValue
                                          );
                                        }}
                                      />
                                      {this.validator.message(
                                        "rent Rate",
                                        values.rentalLogic.rentRate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Rent Rate Term{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.rentRateTerm"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Per Month"
                                          label="Per Month"
                                        />
                                        <option
                                          value="Per Quarter"
                                          label="Per Quarter"
                                        />
                                        <option
                                          value="Per Half Year"
                                          label="Per Half Year"
                                        />
                                        <option
                                          value="Per Year"
                                          label="Per Year"
                                        />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "rent Rate Term",
                                        values.rentalLogic.rentRateTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Rent Frequency
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.rentFrequency"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option value="Monthly" label="Monthly" />
                                        <option
                                          value="Quarterly"
                                          label="Quarterly"
                                        />
                                        <option
                                          value="Half Yearly"
                                          label="Half Yearly"
                                        />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "rent Frequency",
                                        values.rentalLogic.rentFrequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Rent Due Date
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-3 dueDateFieldWidth">
                                      <Field
                                        type="number"
                                        name="rentalLogic.rentDueDate"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                    </div>
                                    <div className="col-sm-3 dueDateFieldWidth">
                                      <Field
                                        as="select"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        name="rentalLogic.rentDueType"
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option value="Date" label="Date" />
                                        <option value="Days" label="Days" />
                                        <option
                                          value="Working Day"
                                          label="Working Day"
                                        />
                                      </Field>
                                    </div>
                                    <div className="col-sm-7 offset-sm-4 mt-3">
                                      <Field
                                        as="select"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        name="rentalLogic.rentDueFrequency"
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Every Month"
                                          label="Every Month"
                                        />
                                        <option
                                          value="Subsequent Month"
                                          label="Subsequent Month"
                                        />
                                        <option
                                          value="Subsequent Quarter"
                                          label="Subsequent Quarter"
                                        />
                                        <option
                                          value="Subsequent Half Year"
                                          label="Subsequent Half Year"
                                        />
                                        <option
                                          value="Subsequent Year"
                                          label="Subsequent Year"
                                        />
                                        <option
                                          value="Next Financial Year"
                                          label="Next Financial Year"
                                        />
                                      </Field>
                                    </div>
                                    <div className="col-sm-7 offset-sm-4">
                                      {this.validator.message(
                                        "rent Due Date",
                                        values.rentalLogic.rentDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row revenueShareRow">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Revenue Share Term{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.revenueShareTerm"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Per Month"
                                          label="Per Month"
                                        />
                                        <option
                                          value="Per Quarter"
                                          label="Per Quarter"
                                        />
                                        <option
                                          value="Per Half Year"
                                          label="Per Half Year"
                                        />
                                        <option
                                          value="Per Year"
                                          label="Per Year"
                                        />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "Revenue Share Term",
                                        values.rentalLogic.revenueShareTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Revenue Share Frequency
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.revenueShareFrequency"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option
                                          value="Quarterly"
                                          label="Quarterly"
                                        />
                                        <option
                                          value="Half Yearly"
                                          label="Half Yearly"
                                        />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "Revenue Share Frequency",
                                        values.rentalLogic.revenueShareFrequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Revenue Share Due Date{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-3 dueDateFieldWidth">
                                      <Field
                                        type="number"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        name="rentalLogic.revenueShareDueDate"
                                      ></Field>
                                    </div>
                                    <div className="col-sm-3 dueDateFieldWidth">
                                      <Field
                                        as="select"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        name="rentalLogic.revenueShareDueType"
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option value="Date" label="Date" />
                                        <option value="Days" label="Days" />
                                        <option
                                          value="Working Day"
                                          label="Working Day"
                                        />
                                      </Field>
                                    </div>
                                    <div className="col-sm-7 offset-sm-4 mt-3">
                                      <Field
                                        as="select"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        name="rentalLogic.revenueShareDueFrequency"
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Every Month"
                                          label="Every Month"
                                        />
                                        <option
                                          value="Subsequent Month"
                                          label="Subsequent Month"
                                        />
                                        <option
                                          value="Subsequent Quarter"
                                          label="Subsequent Quarter"
                                        />
                                        <option
                                          value="Subsequent Half Year"
                                          label="Subsequent Half Year"
                                        />
                                        <option
                                          value="Subsequent Year"
                                          label="Subsequent Year"
                                        />
                                        <option
                                          value="Next Financial Year"
                                          label="Next Financial Year"
                                        />
                                      </Field>
                                    </div>
                                    <div className="col-sm-7 offset-sm-4">
                                      {this.validator.message(
                                        "Revenue Share Due Date",
                                        values.rentalLogic.revenueShareDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Revenue Share Applicability
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={
                                          "rentalLogic.revenueShareApplicability"
                                        }
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="cumulative"
                                          label="Cumulative"
                                        />
                                        <option
                                          value="incremental"
                                          label="Incremental"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "Revenue Share Applicability",
                                        values.rentalLogic
                                          .revenueShareApplicability,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Revenue Share Reconcilitation
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={
                                          "rentalLogic.revenueShareReconcilitation"
                                        }
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option
                                          value="Quarterly"
                                          label="Quarterly"
                                        />
                                        <option
                                          value="Half Yearly"
                                          label="Half Yearly"
                                        />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "Revenue Share Reconcilitation",
                                        values.rentalLogic
                                          .revenueShareReconcilitation,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label">
                                      Revenue Share (%)
                                    </label>
                                    <div className="col-sm-10 slabWidthDesktop">
                                      <div className="tableContainer">
                                        <div className="col-lg-6 mb-4">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-3 col-form-label">
                                                No. of SLABS{" "}
                                                <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  type="text"
                                                  name="rentalLogic.slabNumber"
                                                  value={
                                                    this.state.initialValues
                                                      .totalSlabs
                                                  }
                                                  className="slabInput"
                                                  onChange={(e) => {
                                                    this.addSlabRow(e);
                                                    handleChange(e);
                                                  }}
                                                />
                                                <ErrorMessage
                                                  name="rentalLogic.slabNumber"
                                                  component="div"
                                                  className="text-red"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <table className="table tableSimple">
                                          <thead>
                                            <tr>
                                              <th scope="col">SLAB</th>
                                              <th scope="col">FROM</th>
                                              <th scope="col">To</th>
                                              <th scope="col">
                                                Revenue Share (%)
                                              </th>
                                              <th scope="col" colSpan="">
                                                Action
                                              </th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                            {this.state.initialValues.rentalLogic
                                              .slabs.length > 0 &&
                                              this.state.initialValues.rentalLogic.slabs.map(
                                                (friend, index) => (
                                                  <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                      <Field
                                                        type="text"
                                                        name={`rentalLogic.slabs.${index}.from`}
                                                        onChange={(e) => {
                                                          console.log(
                                                            e.target.value
                                                          );
                                                          this.state.initialValues.rentalLogic.slabs[
                                                            index
                                                          ].from = e.target.value;
                                                          handleChange(e);
                                                        }}
                                                        value={
                                                          this.state.initialValues
                                                            .rentalLogic.slabs[
                                                            index
                                                          ].from
                                                        }
                                                      />
                                                    </td>
                                                    <td>
                                                      <Field
                                                        type="text"
                                                        name={`rentalLogic.slabs.${index}.to`}
                                                        onChange={(e) => {
                                                          console.log(
                                                            e.target.value
                                                          );
                                                          this.state.initialValues.rentalLogic.slabs[
                                                            index
                                                          ].to = e.target.value;
                                                          handleChange(e);
                                                        }}
                                                        value={
                                                          this.state.initialValues
                                                            .rentalLogic.slabs[
                                                            index
                                                          ].to
                                                        }
                                                        onBlur={(e) => {
                                                          if (
                                                            index <
                                                            this.state
                                                              .initialValues
                                                              .rentalLogic.slabs
                                                              .length -
                                                            1
                                                          ) {
                                                            this.getFromForNextSlab(
                                                              e,
                                                              values,
                                                              index
                                                            );
                                                          }
                                                        }}
                                                      />
                                                    </td>
                                                    <td>
                                                      <Field
                                                        type="text"
                                                        name={`rentalLogic.slabs.${index}.percent`}
                                                        onChange={(e) => {
                                                          console.log(
                                                            e.target.value
                                                          );
                                                          this.state.initialValues.rentalLogic.slabs[
                                                            index
                                                          ].percent =
                                                            e.target.value;
                                                          handleChange(e);
                                                        }}
                                                        value={
                                                          this.state.initialValues
                                                            .rentalLogic.slabs[
                                                            index
                                                          ].percent
                                                        }
                                                      />
                                                    </td>
                                                    {/* <td>
                                                        <a
                                                          className="actionAdd"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPlus}
                                                          />
                                                        </a>
                                                      </td>
                                                      <td>
                                                        <a
                                                          className="actionEdit"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPen}
                                                          />
                                                        </a>
                                                      </td> */}
                                                    <td>
                                                      <a
                                                        className="actionDelete"
                                                        href="#"
                                                        onClick={(e) => {
                                                          this.state.initialValues
                                                            .totalSlabs--;
                                                          var _slabs =
                                                            this.state
                                                              .initialValues
                                                              .rentalLogic.slabs;
                                                          _slabs.splice(index, 1);
                                                          this.setState({
                                                            slabs: _slabs,
                                                          });
                                                        }}
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faTimes}
                                                        />
                                                      </a>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {this.state.showMinusCam && (
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Minus CAM %{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="text"
                                          name="rentalLogic.minusCamPercent"
                                        />
                                        {this.validator.message(
                                          "Minus CAM %",
                                          values.rentalLogic.minusCamPercent,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      {this.state.minimumGuaranteeRentRevenueShareProduct && (
                        <div className="minimumGuaranteeRentRevenueShareProduct">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    From <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.fromDate"
                                      value={this.state.fromDate}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "From",
                                      this.state.fromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    To <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.toDate"
                                      value={this.state.toDate}
                                      onChange={(e) => {
                                        console.log(e.target.value);
                                        this.setState({
                                          toDate: e.target.value,
                                        });
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "To",
                                      this.state.toDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent UOM <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentalUom"}
                                      onChange={(e) => {
                                        this.validator =
                                          new SimpleReactValidator({
                                            autoForceUpdate: this,
                                          });
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Sq Ft"
                                        label="Per Sq Ft"
                                      />
                                      <option
                                        value="Flat Amount"
                                        label="Flat Amount"
                                      />
                                    </Field>
                                    {this.validator.message(
                                      "Rent UOM",
                                      values.rentalLogic.rentalUom,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {values.rentalLogic.rentalUom == "Per Sq Ft" && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      On Area
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.onArea"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Usable Area"
                                          label="Usable Area"
                                        />
                                        <option
                                          value="Carpet Area"
                                          label="Carpet Area"
                                        />
                                        <option
                                          value="Gross Leasable Area"
                                          label="Gross Leasable Area"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "On Area",
                                        values.rentalLogic.onArea,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.period > 1 &&
                              this.state.isRentAutocalculate === false && (
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Escalation %
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="number"
                                          name="rentalLogic.escalationPercent"
                                          disabled={this.state.disableOnEdit}
                                          onBlur={(e) => {
                                            this.calculateRentRate(
                                              e,
                                              values,
                                              setFieldValue
                                            );
                                          }}
                                        />
                                        {this.validator.message(
                                          "Escalation %",
                                          values.rentalLogic.escalationPercent,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Rate
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentRate"
                                      onBlur={(e) => {
                                        this.calculateEscalationPercent(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "rent Rate",
                                      values.rentalLogic.rentRate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Rate Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentRateTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "rent Rate Term",
                                      values.rentalLogic.rentRateTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "rent Frequency",
                                      values.rentalLogic.rentFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Due Date
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "rent Due Date",
                                      values.rentalLogic.rentDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row revenueShareRow">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Term",
                                      values.rentalLogic.revenueShareTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Frequency",
                                      values.rentalLogic.revenueShareFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Due Date{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    ></Field>
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "Revenue Share Due Date",
                                      values.rentalLogic.revenueShareDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Applicability
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={
                                        "rentalLogic.revenueShareApplicability"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="cumulative"
                                        label="Cumulative"
                                      />
                                      <option
                                        value="incremental"
                                        label="Incremental"
                                      />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Applicability",
                                      values.rentalLogic
                                        .revenueShareApplicability,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Reconcilitation
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={
                                        "rentalLogic.revenueShareReconcilitation"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Reconcilitation",
                                      values.rentalLogic
                                        .revenueShareReconcilitation,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-2 col-form-label">
                                    Revenue Share (%)
                                  </label>
                                  <div className="col-sm-10 slabWidthDesktop">
                                    <div className="tableContainer">
                                      <div className="col-lg-6 mb-4">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-3 col-form-label">
                                              No. of Products{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="text"
                                                name="rentalLogic.slabNumber"
                                                value={
                                                  this.state.initialValues
                                                    .totalSlabs
                                                }
                                                className="slabInput"
                                                onChange={(e) => {
                                                  this.addSlabRow(e);
                                                  handleChange(e);
                                                }}
                                              />
                                              <ErrorMessage
                                                name="rentalLogic.slabNumber"
                                                component="div"
                                                className="text-red"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <table className="table tableSimple">
                                        <thead>
                                          <tr>
                                            <th scope="col">SLAB</th>
                                            <th scope="col">PRODUCT</th>
                                            <th scope="col">
                                              Revenue Share (%)
                                            </th>
                                            <th scope="col" colSpan="">
                                              Action
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {this.state.initialValues.rentalLogic
                                            .slabs.length > 0 &&
                                            this.state.initialValues.rentalLogic.slabs.map(
                                              (friend, index) => (
                                                <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td>
                                                    <Select
                                                      className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                                      isSearchable="true"
                                                      name={`rentalLogic.slabs.${index}.product`}
                                                      value={{
                                                        label:
                                                          this.state
                                                            .initialValues
                                                            .rentalLogic.slabs[
                                                            index
                                                          ].productName,
                                                        value:
                                                          this.state
                                                            .initialValues
                                                            .rentalLogic.slabs[
                                                            index
                                                          ].product,
                                                      }}
                                                      onChange={(e) => {
                                                        this.changeProduct(
                                                          e,
                                                          values,
                                                          index
                                                        );
                                                      }}
                                                      options={this.state.products.map(
                                                        (item) => ({
                                                          label:
                                                            item.product_name,
                                                          value: item.id,
                                                        })
                                                      )}
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`rentalLogic.slabs.${index}.percent`}
                                                      onChange={(e) => {
                                                        this.state.initialValues.rentalLogic.slabs[
                                                          index
                                                        ].percent =
                                                          e.target.value;
                                                        handleChange(e);
                                                      }}
                                                      value={
                                                        this.state.initialValues
                                                          .rentalLogic.slabs[
                                                          index
                                                        ].percent
                                                      }
                                                    />
                                                  </td>
                                                  {/* <td>
                                                        <a
                                                          className="actionAdd"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPlus}
                                                          />
                                                        </a>
                                                      </td>
                                                      <td>
                                                        <a
                                                          className="actionEdit"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPen}
                                                          />
                                                        </a>
                                                      </td> */}
                                                  <td>
                                                    <a
                                                      className="actionDelete"
                                                      href="#"
                                                      onClick={(e) => {
                                                        this.state.initialValues
                                                          .totalSlabs--;
                                                        var _slabs =
                                                          this.state
                                                            .initialValues
                                                            .rentalLogic.slabs;
                                                        _slabs.splice(index, 1);
                                                        this.setState({
                                                          slabs: _slabs,
                                                        });
                                                      }}
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faTimes}
                                                      />
                                                    </a>
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {this.state.showMinusCam && (
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Minus CAM %{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="rentalLogic.minusCamPercent"
                                      />
                                      {this.validator.message(
                                        "Minus CAM %",
                                        values.rentalLogic.minusCamPercent,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {this.state
                        .minimumGuaranteeRentRevenueShareSalesRangeProduct && (
                          <div className="minimumGuaranteeRentRevenueShareSalesRangeProduct">
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      From <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="date"
                                        name="rentalLogic.fromDate"
                                        value={this.state.fromDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      To <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="date"
                                        name="rentalLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => {
                                          console.log(e.target.value);
                                          this.setState({
                                            toDate: e.target.value,
                                          });
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Rent UOM <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.rentalUom"}
                                        onChange={(e) => {
                                          this.validator =
                                            new SimpleReactValidator({
                                              autoForceUpdate: this,
                                            });
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Per Sq Ft"
                                          label="Per Sq Ft"
                                        />
                                        <option
                                          value="Flat Amount"
                                          label="Flat Amount"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "Rent UOM",
                                        values.rentalLogic.rentalUom,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {values.rentalLogic.rentalUom == "Per Sq Ft" && (
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        On Area
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          as="select"
                                          name={"rentalLogic.onArea"}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option
                                            value="Usable Area"
                                            label="Usable Area"
                                          />
                                          <option
                                            value="Carpet Area"
                                            label="Carpet Area"
                                          />
                                          <option
                                            value="Gross Leasable Area"
                                            label="Gross Leasable Area"
                                          />
                                        </Field>
                                        {this.validator.message(
                                          "On Area",
                                          values.rentalLogic.onArea,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {this.state.period > 1 &&
                                this.state.isRentAutocalculate === false && (
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Escalation %
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="rentalLogic.escalationPercent"
                                            disabled={this.state.disableOnEdit}
                                            onBlur={(e) => {
                                              this.calculateRentRate(
                                                e,
                                                values,
                                                setFieldValue
                                              );
                                            }}
                                          />
                                          {this.validator.message(
                                            "Escalation %",
                                            values.rentalLogic.escalationPercent,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Rent Rate
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="number"
                                        name="rentalLogic.rentRate"
                                        onBlur={(e) => {
                                          this.calculateEscalationPercent(
                                            e,
                                            values,
                                            setFieldValue
                                          );
                                        }}
                                      />
                                      {this.validator.message(
                                        "rent Rate",
                                        values.rentalLogic.rentRate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Rent Rate Term{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.rentRateTerm"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Per Month"
                                          label="Per Month"
                                        />
                                        <option
                                          value="Per Quarter"
                                          label="Per Quarter"
                                        />
                                        <option
                                          value="Per Half Year"
                                          label="Per Half Year"
                                        />
                                        <option
                                          value="Per Year"
                                          label="Per Year"
                                        />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "rent Rate Term",
                                        values.rentalLogic.rentRateTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Rent Frequency
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.rentFrequency"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option value="Monthly" label="Monthly" />
                                        <option
                                          value="Quarterly"
                                          label="Quarterly"
                                        />
                                        <option
                                          value="Half Yearly"
                                          label="Half Yearly"
                                        />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "rent Frequency",
                                        values.rentalLogic.rentFrequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Rent Due Date
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-3 dueDateFieldWidth">
                                      <Field
                                        type="number"
                                        name="rentalLogic.rentDueDate"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                    </div>
                                    <div className="col-sm-3 dueDateFieldWidth">
                                      <Field
                                        as="select"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        name="rentalLogic.rentDueType"
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option value="Date" label="Date" />
                                        <option value="Days" label="Days" />
                                        <option
                                          value="Working Day"
                                          label="Working Day"
                                        />
                                      </Field>
                                    </div>
                                    <div className="col-sm-7 offset-sm-4 mt-3">
                                      <Field
                                        as="select"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        name="rentalLogic.rentDueFrequency"
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Every Month"
                                          label="Every Month"
                                        />
                                        <option
                                          value="Subsequent Month"
                                          label="Subsequent Month"
                                        />
                                        <option
                                          value="Subsequent Quarter"
                                          label="Subsequent Quarter"
                                        />
                                        <option
                                          value="Subsequent Half Year"
                                          label="Subsequent Half Year"
                                        />
                                        <option
                                          value="Subsequent Year"
                                          label="Subsequent Year"
                                        />
                                        <option
                                          value="Next Financial Year"
                                          label="Next Financial Year"
                                        />
                                      </Field>
                                    </div>
                                    <div className="col-sm-7 offset-sm-4">
                                      {this.validator.message(
                                        "rent Due Date",
                                        values.rentalLogic.rentDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row revenueShareRow">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Revenue Share Term{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.revenueShareTerm"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Per Month"
                                          label="Per Month"
                                        />
                                        <option
                                          value="Per Quarter"
                                          label="Per Quarter"
                                        />
                                        <option
                                          value="Per Half Year"
                                          label="Per Half Year"
                                        />
                                        <option
                                          value="Per Year"
                                          label="Per Year"
                                        />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "Revenue Share Term",
                                        values.rentalLogic.revenueShareTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Revenue Share Frequency
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.revenueShareFrequency"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option
                                          value="Quarterly"
                                          label="Quarterly"
                                        />
                                        <option
                                          value="Half Yearly"
                                          label="Half Yearly"
                                        />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "Revenue Share Frequency",
                                        values.rentalLogic.revenueShareFrequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Revenue Share Due Date{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-3 dueDateFieldWidth">
                                      <Field
                                        type="number"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        name="rentalLogic.revenueShareDueDate"
                                      ></Field>
                                    </div>
                                    <div className="col-sm-3 dueDateFieldWidth">
                                      <Field
                                        as="select"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        name="rentalLogic.revenueShareDueType"
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option value="Date" label="Date" />
                                        <option value="Days" label="Days" />
                                        <option
                                          value="Working Day"
                                          label="Working Day"
                                        />
                                      </Field>
                                    </div>
                                    <div className="col-sm-7 offset-sm-4 mt-3">
                                      <Field
                                        as="select"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        name="rentalLogic.revenueShareDueFrequency"
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Every Month"
                                          label="Every Month"
                                        />
                                        <option
                                          value="Subsequent Month"
                                          label="Subsequent Month"
                                        />
                                        <option
                                          value="Subsequent Quarter"
                                          label="Subsequent Quarter"
                                        />
                                        <option
                                          value="Subsequent Half Year"
                                          label="Subsequent Half Year"
                                        />
                                        <option
                                          value="Subsequent Year"
                                          label="Subsequent Year"
                                        />
                                        <option
                                          value="Next Financial Year"
                                          label="Next Financial Year"
                                        />
                                      </Field>
                                    </div>
                                    <div className="col-sm-7 offset-sm-4">
                                      {this.validator.message(
                                        "Revenue Share Due Date",
                                        values.rentalLogic.revenueShareDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Revenue Share Applicability
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={
                                          "rentalLogic.revenueShareApplicability"
                                        }
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="cumulative"
                                          label="Cumulative"
                                        />
                                        <option
                                          value="incremental"
                                          label="Incremental"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "Revenue Share Applicability",
                                        values.rentalLogic
                                          .revenueShareApplicability,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Revenue Share Reconcilitation
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={
                                          "rentalLogic.revenueShareReconcilitation"
                                        }
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option
                                          value="Quarterly"
                                          label="Quarterly"
                                        />
                                        <option
                                          value="Half Yearly"
                                          label="Half Yearly"
                                        />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "Revenue Share Reconcilitation",
                                        values.rentalLogic
                                          .revenueShareReconcilitation,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label">
                                      Revenue Share (%)
                                    </label>
                                    <div className="col-sm-10 slabWidthDesktop">
                                      <div className="tableContainer">
                                        <div className="col-lg-6 mb-4">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-3 col-form-label">
                                                No. of Products & Sales Slabs{" "}
                                                <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  type="text"
                                                  name="rentalLogic.slabNumber"
                                                  value={
                                                    this.state.initialValues
                                                      .totalSlabs
                                                  }
                                                  className="slabInput"
                                                  onChange={(e) => {
                                                    this.addSlabRow(e);
                                                    handleChange(e);
                                                  }}
                                                />
                                                <ErrorMessage
                                                  name="rentalLogic.slabNumber"
                                                  component="div"
                                                  className="text-red"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <table className="table tableSimple">
                                          <thead>
                                            <tr>
                                              <th scope="col">SLAB</th>
                                              <th scope="col">PRODUCT</th>
                                              <th scope="col">FROM</th>
                                              <th scope="col">TO</th>
                                              <th scope="col">
                                                Revenue Share (%)
                                              </th>
                                              <th scope="col" colSpan="">
                                                Action
                                              </th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                            {this.state.initialValues.rentalLogic
                                              .slabs.length > 0 &&
                                              this.state.initialValues.rentalLogic.slabs.map(
                                                (friend, index) => (
                                                  <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td
                                                      style={{ width: "200px" }}
                                                    >
                                                      <Select
                                                        className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                                        isSearchable="true"
                                                        name={`rentalLogic.slabs.${index}.product`}
                                                        value={{
                                                          label:
                                                            this.state
                                                              .initialValues
                                                              .rentalLogic.slabs[
                                                              index
                                                            ].productName,
                                                          value:
                                                            this.state
                                                              .initialValues
                                                              .rentalLogic.slabs[
                                                              index
                                                            ].product,
                                                        }}
                                                        onChange={(e) => {
                                                          this.changeProduct(
                                                            e,
                                                            values,
                                                            index
                                                          );
                                                        }}
                                                        options={this.state.products.map(
                                                          (item) => ({
                                                            label:
                                                              item.product_name,
                                                            value: item.id,
                                                          })
                                                        )}
                                                      />
                                                    </td>
                                                    <td>
                                                      <Field
                                                        type="text"
                                                        name={`rentalLogic.slabs.${index}.from`}
                                                        onChange={(e) => {
                                                          console.log(
                                                            e.target.value
                                                          );
                                                          this.state.initialValues.rentalLogic.slabs[
                                                            index
                                                          ].from = e.target.value;
                                                          handleChange(e);
                                                        }}
                                                        value={
                                                          this.state.initialValues
                                                            .rentalLogic.slabs[
                                                            index
                                                          ].from
                                                        }
                                                      />
                                                    </td>
                                                    <td>
                                                      <Field
                                                        type="text"
                                                        name={`rentalLogic.slabs.${index}.to`}
                                                        onChange={(e) => {
                                                          this.state.initialValues.rentalLogic.slabs[
                                                            index
                                                          ].to = e.target.value;
                                                          handleChange(e);
                                                        }}
                                                        value={
                                                          this.state.initialValues
                                                            .rentalLogic.slabs[
                                                            index
                                                          ].to
                                                        }
                                                        onBlur={(e) => {
                                                          if (
                                                            index <
                                                            this.state
                                                              .initialValues
                                                              .rentalLogic.slabs
                                                              .length -
                                                            1
                                                          ) {
                                                            this.getFromForNextSlab(
                                                              e,
                                                              values,
                                                              index
                                                            );
                                                          }
                                                        }}
                                                      />
                                                    </td>
                                                    <td>
                                                      <Field
                                                        type="text"
                                                        name={`rentalLogic.slabs.${index}.percent`}
                                                        onChange={(e) => {
                                                          console.log(
                                                            e.target.value
                                                          );
                                                          this.state.initialValues.rentalLogic.slabs[
                                                            index
                                                          ].percent =
                                                            e.target.value;
                                                          handleChange(e);
                                                        }}
                                                        value={
                                                          this.state.initialValues
                                                            .rentalLogic.slabs[
                                                            index
                                                          ].percent
                                                        }
                                                      />
                                                    </td>
                                                    {/* <td>
                                                        <a
                                                          className="actionAdd"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPlus}
                                                          />
                                                        </a>
                                                      </td>
                                                      <td>
                                                        <a
                                                          className="actionEdit"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPen}
                                                          />
                                                        </a>
                                                      </td> */}
                                                    <td>
                                                      <a
                                                        className="actionDelete"
                                                        href="#"
                                                        onClick={(e) => {
                                                          this.state.initialValues
                                                            .totalSlabs--;
                                                          var _slabs =
                                                            this.state
                                                              .initialValues
                                                              .rentalLogic.slabs;
                                                          _slabs.splice(index, 1);
                                                          this.setState({
                                                            slabs: _slabs,
                                                          });
                                                        }}
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faTimes}
                                                        />
                                                      </a>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {this.state.showMinusCam && (
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Minus CAM %{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="text"
                                          name="rentalLogic.minusCamPercent"
                                        />
                                        {this.validator.message(
                                          "Minus CAM %",
                                          values.rentalLogic.minusCamPercent,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      {this.state.minimumGuaranteeRentRevenueShareMinimum && (
                        <div className="minimumGuaranteeRentRevenueShareMinimum">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    From <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.fromDate"
                                      value={this.state.fromDate}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "From",
                                      this.state.fromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    To <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="date"
                                      name="rentalLogic.toDate"
                                      value={this.state.toDate}
                                      onChange={(e) => {
                                        console.log(e.target.value);
                                        this.setState({
                                          toDate: e.target.value,
                                        });
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "To",
                                      this.state.toDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent UOM <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentalUom"}
                                      onChange={(e) => {
                                        this.validator =
                                          new SimpleReactValidator({
                                            autoForceUpdate: this,
                                          });
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Sq Ft"
                                        label="Per Sq Ft"
                                      />
                                      <option
                                        value="Flat Amount"
                                        label="Flat Amount"
                                      />
                                    </Field>
                                    {this.validator.message(
                                      "Rent UOM",
                                      values.rentalLogic.rentalUom,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {values.rentalLogic.rentalUom == "Per Sq Ft" && (
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      On Area
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"rentalLogic.onArea"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Usable Area"
                                          label="Usable Area"
                                        />
                                        <option
                                          value="Carpet Area"
                                          label="Carpet Area"
                                        />
                                        <option
                                          value="Gross Leasable Area"
                                          label="Gross Leasable Area"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "On Area",
                                        values.rentalLogic.onArea,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.period > 1 &&
                              this.state.isRentAutocalculate === false && (
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Escalation %
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="number"
                                          name="rentalLogic.escalationPercent"
                                          disabled={this.state.disableOnEdit}
                                          onBlur={(e) => {
                                            this.calculateRentRate(
                                              e,
                                              values,
                                              setFieldValue
                                            );
                                          }}
                                        />
                                        {this.validator.message(
                                          "Escalation %",
                                          values.rentalLogic.escalationPercent,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Rate
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentRate"
                                      onBlur={(e) => {
                                        this.calculateEscalationPercent(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "rent Rate",
                                      values.rentalLogic.rentRate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Rate Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentRateTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "rent Rate Term",
                                      values.rentalLogic.rentRateTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.rentFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "rent Frequency",
                                      values.rentalLogic.rentFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Rent Due Date
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "rent Due Date",
                                      values.rentalLogic.rentDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row revenueShareRow">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share (%){" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="number"
                                      name="rentalLogic.revenueShare"
                                    />
                                    {this.validator.message(
                                      "Revenue Share %",
                                      values.rentalLogic.revenueShare,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Term{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Per Month"
                                        label="Per Month"
                                      />
                                      <option
                                        value="Per Quarter"
                                        label="Per Quarter"
                                      />
                                      <option
                                        value="Per Half Year"
                                        label="Per Half Year"
                                      />
                                      <option
                                        value="Per Year"
                                        label="Per Year"
                                      />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Term",
                                      values.rentalLogic.revenueShareTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Frequency
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"rentalLogic.revenueShareFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Frequency",
                                      values.rentalLogic.revenueShareFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Due Date{" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    ></Field>
                                  </div>
                                  <div className="col-sm-3 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-7 offset-sm-4">
                                    {this.validator.message(
                                      "Revenue Share Due Date",
                                      values.rentalLogic.revenueShareDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Revenue Share Reconcilitation
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={
                                        "rentalLogic.revenueShareReconcilitation"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option
                                        value="Quarterly"
                                        label="Quarterly"
                                      />
                                      <option
                                        value="Half Yearly"
                                        label="Half Yearly"
                                      />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Revenue Share Reconcilitation",
                                      values.rentalLogic
                                        .revenueShareReconcilitation,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {this.state.showMinusCam && (
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Minus CAM %{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="rentalLogic.minusCamPercent"
                                      />
                                      {this.validator.message(
                                        "Minus CAM %",
                                        values.rentalLogic.minusCamPercent,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {this.state.showAddBtn && (
                        <div className="row">
                          <div className="col-lg-6 offset-lg-6">
                            <div className="btnContainer">
                              <div>
                                {this.state.isRentAutocalculate === false && (
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      this.addRentalDetails(
                                        values,
                                        resetForm,
                                        setFieldValue
                                      );
                                    }}
                                  >
                                    Add
                                  </button>
                                )}
                                {this.state.isRentAutocalculate === true && (
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      this.calculateRent(values, resetForm);
                                    }}
                                  >
                                    Create
                                  </button>
                                )}
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    this.resetRentalDetails(values, resetForm);
                                  }}
                                >
                                  Reset
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <span className="remarks">Notes/Remarks</span>
                  <Field as="textarea" className="notes mb-3" name="notes_5" />
                  <div className="rentals m-0">
                    <div className="row">
                      <div className="col">
                        {this.mainFormValidator.message(
                          "Rental Details",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                      <div className="tableContainer">
                        <table className="table tableSimple">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              {/* <th scope="col">Period</th>
                              <th scope="col">Period Term (YY-MM-DD)</th> */}
                              <th scope="col">From</th>
                              <th scope="col">To</th>
                              <th scope="col">Rental Logic</th>
                              <th scope="col">Rental Rate</th>
                              {this.state.isRentAutocalculate === false && (
                                <th scope="col" colSpan="2">
                                  Action
                                </th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.rentalDetails.map(function (
                              name,
                              index
                            ) {
                              return (
                                <tr key={"rentalTable" + index}>
                                  <td>{index + 1}</td>
                                  {/* <td>
                                    <a
                                      className="popupLink"
                                      onClick={(e) => {
                                        this.state.popupData = name;
                                        this.openModal();
                                      }}
                                    >
                                      {name.period}
                                    </a>
                                  </td> */}
                                  {/* <td>
                                    {name.periodTermYY == ""
                                      ? "0"
                                      : name.periodTermYY}
                                    {"-"}
                                    {name.periodTermMM == ""
                                      ? "0"
                                      : name.periodTermMM}
                                    {"-"}
                                    {name.periodTermDD == ""
                                      ? "0"
                                      : name.periodTermDD}
                                  </td> */}
                                  <td>{leaseDateFormat(name.fromDate)}</td>
                                  <td>{leaseDateFormat(name.toDate)}</td>
                                  <td>{name.rentalLogicText}</td>
                                  <td>{name.rentRate}</td>
                                  {this.state.isRentAutocalculate === false && (
                                    <td>
                                      <button
                                        type="button"
                                        className="tableActionEdit rentalEdit"
                                        onClick={(e) => {
                                          this.editRental(
                                            index,
                                            values,
                                            setFieldValue
                                          );
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faPen} />
                                      </button>
                                      {this.state.rentalDetails.length ==
                                        index + 1 && (
                                          <button
                                            type="button"
                                            className="actionDelete rentalDeleteButton"
                                            onClick={(e) => {
                                              this.setState({
                                                delete: true,
                                                index_val: index,
                                                revalue: values.from,
                                              });
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faTimes} />
                                          </button>
                                        )}
                                    </td>
                                  )}
                                </tr>
                              );
                            },
                              this)}
                          </tbody>
                        </table>
                        <div className="col-lg-6 offset-lg-6">
                          <div className="button_group d-flex align-items-center gap-2 justify-content-end mt-4">
  <button className="add_button" type="submit">
    Save Draft
  </button>
  <button className="reset_button" type="submit">
    <Link to="/createlease">
      Cancel
    </Link>
  </button>
</div>

                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <Modal
                show={this.state.isOpen}
                onHide={this.closeModal}
                size="lg"
                className="documentModal"
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <div className="container modalBreadCrumbs">
                      <div className="row">
                        <div className="col-lg-12">
                          <ul>
                            <li>Rental Details</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.state.isOpen && this.rentalPopup(this.state.popupData)}
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
      </div>
    );
  }

  rentalPopup(rental) {
    console.log(rental);
    if (rental.rentalLogicValue == 1 || rental.rentalLogicValue == 2) {
      return this.rentMinusCamPopup(rental);
    } else if (rental.rentalLogicValue == 3 || rental.rentalLogicValue == 4) {
      return this.rentPlusFitoutMinusCamPopup(rental);
    } else if (rental.rentalLogicValue == 5 || rental.rentalLogicValue == 6) {
      return this.pureRevenueShareMinusCamPopup(rental);
    } else if (rental.rentalLogicValue == 7 || rental.rentalLogicValue == 8) {
      return this.pureRevenueShareSalesRangeMinusCamPopup(rental);
    } else if (rental.rentalLogicValue == 9 || rental.rentalLogicValue == 10) {
      return this.pureRevenueShareProductMinusCamPopup(rental);
    } else if (rental.rentalLogicValue == 11 || rental.rentalLogicValue == 12) {
      return this.pureRevenueShareSalesRangeProductMinusCamPopup(rental);
    } else if (
      rental.rentalLogicValue == 13 ||
      rental.rentalLogicValue == 14 ||
      rental.rentalLogicValue == 15
    ) {
      return this.minimumGuaranteeRentPlusCamMinusCam(rental);
    } else if (rental.rentalLogicValue == 16 || rental.rentalLogicValue == 17) {
      return this.minimumGuaranteeRentPlusFitoutRevenueShareMinusCam(rental);
    } else if (rental.rentalLogicValue == 18 || rental.rentalLogicValue == 19) {
      return this.minimumGuaranteeRentRevenueShareSalesMinusCam(rental);
    } else if (rental.rentalLogicValue == 20 || rental.rentalLogicValue == 21) {
      return this.minimumGuaranteeRentRevenueShareProductMinusCam(rental);
    } else if (rental.rentalLogicValue == 22 || rental.rentalLogicValue == 23) {
      return this.minimumGuaranteeRentRevenueShareSalesProductMinusCam(rental);
    } else if (
      rental.rentalLogicValue == 24 ||
      rental.rentalLogicValue == 25 ||
      rental.rentalLogicValue == 26 ||
      rental.rentalLogicValue == 27
    ) {
      return this.minimumGuaranteeRentOrRevenueShareMinusCam(rental);
    }
  }

  rentMinusCamPopup(rental) {
    if (this.state.isRentAutocalculate === false) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4 className="popupHeading">{rental.rentalLogicText}</h4>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.period}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                    {"-"}
                    {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                    {"-"}
                    {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rental Logic <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalLogicText}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    From <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {/* {leaseDateFormat(rental.fromDate)} */}
                    {leaseDateFormat(rental.fromDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    To <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {/* {leaseDateFormat(rental.toDate)} */}
                    {leaseDateFormat(rental.toDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalUom}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.onArea}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRate}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentFrequency}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Due Date <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentDueDate}
                  </label>
                </div>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4 className="popupHeading">{rental.rentalLogicText}</h4>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.period}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period Duration <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.periodDurationYY == ""
                      ? "0"
                      : rental.periodDurationYY}
                    {"-"}
                    {rental.periodDurationMM == ""
                      ? "0"
                      : rental.periodDurationMM}
                    {"-"}
                    {rental.periodDurationDD == ""
                      ? "0"
                      : rental.periodDurationDD}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Escalation Percent <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.escalationPercent}
                  </label>
                </div>
              </div>
            </div>
            {rental.unit !== undefined && (
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Unit <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {rental.unit}
                    </label>
                  </div>
                </div>
              </div>
            )}
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rental Logic <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalLogicText}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    From <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(rental.fromDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    To <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(rental.toDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalUom}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.onArea}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRate}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentFrequency}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Due Date <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentDueDate}
                  </label>
                </div>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
  }

  rentPlusFitoutMinusCamPopup(rental) {
    if (this.state.isRentAutocalculate === false) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4 className="popupHeading">{rental.rentalLogicText}</h4>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.period}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                    {"-"}
                    {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                    {"-"}
                    {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rental Logic <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalLogicText}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    From <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(rental.fromDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    To <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(rental.toDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalUom}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.onArea}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRate}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentFrequency}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Due Date <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentDueDate}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rate UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutUom}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutOnArea}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rate <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutRate}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rent Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutFrequency}
                  </label>
                </div>
              </div>
            </div>
            {rental.rentalLogicText.includes("Minus CAM") && (
              <div className="col-lg-6 fitoutPopup">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Minus CAM % <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {rental.minusCamPercent}
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4 className="popupHeading">{rental.rentalLogicText}</h4>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.period}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period Duration <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.periodDurationYY == ""
                      ? "0"
                      : rental.periodDurationYY}
                    {"-"}
                    {rental.periodDurationMM == ""
                      ? "0"
                      : rental.periodDurationMM}
                    {"-"}
                    {rental.periodDurationDD == ""
                      ? "0"
                      : rental.periodDurationDD}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Escalation Percent <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.escalationPercent}
                  </label>
                </div>
              </div>
            </div>
            {rental.unit !== undefined && (
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Unit <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {rental.unit}
                    </label>
                  </div>
                </div>
              </div>
            )}
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rental Logic <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalLogicText}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    From <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(rental.fromDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    To <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(rental.toDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalUom}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.onArea}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRate}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentFrequency}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Due Date <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentDueDate}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rate UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutUom}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutOnArea}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rate <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutRate}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rent Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutFrequency}
                  </label>
                </div>
              </div>
            </div>
            {rental.rentalLogicText.includes("Minus CAM") && (
              <div className="col-lg-6 fitoutPopup">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Minus CAM % <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {rental.minusCamPercent}
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }
  }

  pureRevenueShareMinusCamPopup(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share (%) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShare}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  pureRevenueShareSalesRangeMinusCamPopup(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Applicability <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareApplicability}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">FROM</th>
                          <th scope="col">To</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rental.slabs.length > 0 &&
                          rental.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.from}</td>
                              <td>{name.to}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  pureRevenueShareProductMinusCamPopup(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Applicability <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareApplicability}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">Product</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rental.slabs.length > 0 &&
                          rental.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.productName}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  pureRevenueShareSalesRangeProductMinusCamPopup(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Applicability <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareApplicability}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">Product</th>
                          <th scope="col">From</th>
                          <th scope="col">To</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rental.slabs.length > 0 &&
                          rental.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.productName}</td>
                              <td>{name.from}</td>
                              <td>{name.to}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  minimumGuaranteeRentPlusCamMinusCam(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.onArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share (%) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShare}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  minimumGuaranteeRentPlusFitoutRevenueShareMinusCam(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.onArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share (%) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShare}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup revenue">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Fitout Rate UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.fitoutUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup revenue">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Fitout On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.fitoutOnArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup revenue">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Fitout Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.fitoutRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup revenue">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Fitout Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.fitoutRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12 fitoutPopup revenue">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Fitout Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.fitoutFrequency}
                </label>
              </div>
            </div>
          </div>
        </div>
        {rental.rentalLogicText.includes("Minus CAM") && (
          <div className="row">
            <div className="col-lg-12 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  minimumGuaranteeRentRevenueShareSalesMinusCam(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.onArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Applicability <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareApplicability}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">FROM</th>
                          <th scope="col">To</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rental.slabs.length > 0 &&
                          rental.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.from}</td>
                              <td>{name.to}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  minimumGuaranteeRentRevenueShareProductMinusCam(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.onArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Applicability <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareApplicability}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">Product</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rental.slabs.length > 0 &&
                          rental.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.productName}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  minimumGuaranteeRentRevenueShareSalesProductMinusCam(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.onArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Applicability <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareApplicability}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">Product</th>
                          <th scope="col">From</th>
                          <th scope="col">To</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rental.slabs.length > 0 &&
                          rental.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.productName}</td>
                              <td>{name.from}</td>
                              <td>{name.to}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  minimumGuaranteeRentOrRevenueShareMinusCam(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.onArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share (%) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShare}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default withRouter(Waiver);
